// extracted by mini-css-extract-plugin
module.exports = {"home-tab-bar":"style_home-tab-bar__2vOP6"};